/**
 * AdminOrcaAlertRpcClient - AtomRpc integration for admin orca SMS-alert endpoints
 *
 * Backs the `/orca/defaults` "SMS alerts" card: `admin.orcaAlerts.status`
 * (masked channel status) and `admin.orcaAlerts.sendTest` (operator test send).
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaAlertRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaAlertRpcClient extends AtomRpc.Tag<AdminOrcaAlertRpcClient>()(
  "AdminOrcaAlertRpcClient",
  {
    group: AdminOrcaAlertRpcs,
    protocol: makeRpcClientLayer(AdminOrcaAlertRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
